import { Link, type ErrorComponentProps } from "@tanstack/react-router";
import { t } from "@/i18n";
import { errorMessage } from "@/lib/errors";
import { Button } from "../ui/button";
import { Logo } from "./Logo";

export function NotFoundPage() {
  return (
    <main className="grid min-h-full place-items-center p-6">
      <div className="grid max-w-sm justify-items-center gap-3 text-center">
        <Logo />
        <h1 className="text-2xl font-semibold">{t("notFound.title")}</h1>
        <p className="text-sm text-muted-foreground">{t("notFound.desc")}</p>
        <Button asChild>
          <Link to="/">{t("notFound.home")}</Link>
        </Button>
      </div>
    </main>
  );
}

export function RootErrorPage({ error, reset }: ErrorComponentProps) {
  return (
    <main className="grid min-h-full place-items-center p-6">
      <div className="grid max-w-md justify-items-center gap-3 text-center">
        <Logo />
        <h1 className="text-xl font-semibold">{t("common.errorTitle")}</h1>
        <p className="text-sm text-muted-foreground">{errorMessage(error)}</p>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => reset()}>
            {t("common.retry")}
          </Button>
          <Button asChild>
            <Link to="/">{t("notFound.home")}</Link>
          </Button>
        </div>
      </div>
    </main>
  );
}
